import { render, staticRenderFns } from "./platformByProductOrder.vue?vue&type=template&id=5ec1d39d&scoped=true"
import script from "./platformByProductOrder.vue?vue&type=script&lang=js"
export * from "./platformByProductOrder.vue?vue&type=script&lang=js"
import style0 from "./platformByProductOrder.vue?vue&type=style&index=0&id=5ec1d39d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec1d39d",
  null
  
)

export default component.exports